import {
  GET_SCHEME_COUNT,
  GET_SCHEME_COUNT_SUCCESS,
  GET_SCHEME_COUNT_FAILED,
} from "../actions";

export const initialState = {
  schemeOverview: {
    loading: false,
    data: [],
    error: null,
  },
};

export function schemeOverviewReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SCHEME_COUNT: {
      return {
        ...state,
        schemeOverview: {
          loading: true,
          data: [],
          error: null,
        },
      };
    }
    case GET_SCHEME_COUNT_SUCCESS: {
      return {
        ...state,
        schemeOverview: {
          loading: false,
          data: action?.payload,
          error: null,
        },
      };
    }
    case GET_SCHEME_COUNT_FAILED:
      return {
        ...state,
        schemeOverview: {
          loading: false,
          data: [],
          error: action?.error,
        },
      };

    default:
      return state;
  }
}

export default schemeOverviewReducer;
